export const KiteMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <g transform="rotate(14 32 26)">
      <path d="M32 2 L56 26 L32 50 L8 26 Z" fill="#14355c" />
      <path d="M32 2 L56 26 L32 26 Z" fill="#f0b52f" />
      <path d="M32 2 L32 26 L8 26 Z" fill="#cf4b26" />
      <path d="M32 26 L56 26 L32 50 Z" fill="#2e7f86" />
      <path d="M32 2 L56 26 L32 50 L8 26 Z" fill="none" stroke="#14355c" strokeWidth="2.5" />
      <path d="M32 2 L32 50 M8 26 L56 26" stroke="#14355c" strokeWidth="2" />
    </g>
    <path d="M34 50 C 28 54, 40 56, 33 61" fill="none" stroke="#14355c" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M30 53 L36 51" stroke="#cf4b26" strokeWidth="4" strokeLinecap="round" />
    <path d="M34 58 L40 57" stroke="#f0b52f" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.02c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 4.54 0 8.24 3.7 8.24 8.24s-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.28z" />
  </svg>
);

const Logo = ({ light = false, compact = false }) => (
  <span className="inline-flex items-center" data-testid="brand-logo">
    <img
      src="/logo-full.png"
      alt="Wind Skaters — Team Odisha"
      className={`${compact ? "h-9" : "h-12 sm:h-14"} w-auto ${
        light ? "drop-shadow-[0_2px_10px_rgba(0,0,0,0.45)]" : ""
      }`}
      data-testid="logo-image"
    />
  </span>
);

export default Logo;
